import { FC, useMemo, useState } from "react";

import { SearchSelectInput } from ".";
import _ from "lodash";
import { useInsurers } from "hooks/data/use-insurers";

interface RegularInsurerPickerProps {
  id: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  optionsLoading?: boolean;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  rounded?: boolean;
  rawId?: boolean;
  description?: string;
  multiple?: boolean;
}

const RegularInsurerPicker: FC<RegularInsurerPickerProps> = ({
  id,
  label,
  rawId,
  description,
  labelHidden,
  required,
  multiple,
  ...form
}) => {
  const { insurers, loading } = useInsurers({
    page: 1,
    pageSize: 500,
    search: "",
    searchFields: ["code", "batchCode"],
    sort: "",
  });
  const [query] = useState("");
  const options = useMemo(
    () =>
      insurers.map(({ ...rest }) => ({
        label: rest.insurer_company_name,
        value: rawId ? rest?.insurer_id : { ...rest },
      })),
    [insurers]
  );

  const filteredOptions =
    query === ""
      ? options
      : options.filter((option) => {
          return option.label?.toLowerCase().includes(query.toLowerCase());
        });

  return (
    <SearchSelectInput
      id={id ?? ""}
      label={label ?? ""}
      labelHidden={labelHidden}
      description={description}
      required={required}
      placeholder={loading ? "Loading please wait ..." : "Search Insurer"}
      optionsLoading={loading}
      rawId={rawId}
      multiple={multiple}
      options={(filteredOptions || [])?.map((item: any) => ({
        label: {
          title: item.label as string,
        },
        value: item?.value?.toString(),
      }))}
      {...form}
    />
  );
};

export default RegularInsurerPicker;
